// Mock data for offline UI development and demo mode.
// ≥ 20 biomarkers (mixed normal/altered), ≥ 4 algorithms with populated arrays.

export const MOCK_RESPONSE = {
  success: true,
  labName: "Echevarne",
  originalFileName: "analisis_demo.pdf",
  message: "Successfully parsed PDF. Generated 24 biomarker entries.",
  resContent: [
    "W02181705|W02181705|375978A|Marta|Garcia|H0000H0003|HEMATOCRITO|N||42,1|1|%|36|46|36 - 46",
    "W02181705|W02181705|375978A|Marta|Garcia|H0000H0004|HEMOGLOBINA|N||14,2|1|g/dL|12|16|12 - 16",
    "W02181705|W02181705|375978A|Marta|Garcia|H0000H0005|HEMATIES|N||4,6|1|10^6/uL|4|5,5|4 - 5,5",
    "W02181705|W02181705|375978A|Marta|Garcia|H0000H0006|LEUCOCITOS|N||6,2|1|10^3/uL|4|11|4 - 11",
    "W02181705|W02181705|375978A|Marta|Garcia|H0000H0007|PLAQUETAS|N||248|1|10^3/uL|150|400|150 - 400",
    "W02181705|W02181705|375978A|Marta|Garcia|H0000H0008|VCM|N||89|1|fL|80|99|80 - 99",
    "W02181705|W02181705|375978A|Marta|Garcia|B0000B0001|GLUCOSA|H||108|1|mg/dL|70|100|70 - 100",
    "W02181705|W02181705|375978A|Marta|Garcia|B0000B0002|HBA1C|N||5,4|1|%|4|5,7|4 - 5,7",
    "W02181705|W02181705|375978A|Marta|Garcia|L0000L0001|COLESTEROL TOTAL|H||221|1|mg/dL|0|200|< 200",
    "W02181705|W02181705|375978A|Marta|Garcia|L0000L0002|HDL COLESTEROL|N||62|1|mg/dL|40|100|> 40",
    "W02181705|W02181705|375978A|Marta|Garcia|L0000L0003|LDL COLESTEROL|H||142|1|mg/dL|0|130|< 130",
    "W02181705|W02181705|375978A|Marta|Garcia|L0000L0004|TRIGLICERIDOS|N||98|1|mg/dL|0|150|< 150",
    "W02181705|W02181705|375978A|Marta|Garcia|F0000F0001|GOT|N||22|1|U/L|10|40|10 - 40",
    "W02181705|W02181705|375978A|Marta|Garcia|F0000F0002|GPT|N||28|1|U/L|10|45|10 - 45",
    "W02181705|W02181705|375978A|Marta|Garcia|F0000F0003|GGT|N||19|1|U/L|6|42|6 - 42",
    "W02181705|W02181705|375978A|Marta|Garcia|R0000R0001|UREA|N||34|1|mg/dL|10|50|10 - 50",
    "W02181705|W02181705|375978A|Marta|Garcia|R0000R0002|CREATININA|N||0,82|1|mg/dL|0,5|1,1|0,5 - 1,1",
    "W02181705|W02181705|375978A|Marta|Garcia|M0000M0001|CALCIO|N||9,4|1|mg/dL|8,5|10,5|8,5 - 10,5",
    "W02181705|W02181705|375978A|Marta|Garcia|M0000M0002|MAGNESIO|L||1,7|1|mg/dL|1,8|2,5|1,8 - 2,5",
    "W02181705|W02181705|375978A|Marta|Garcia|M0000M0003|ZINC|L||62|1|ug/dL|70|150|70 - 150",
    "W02181705|W02181705|375978A|Marta|Garcia|M0000M0004|HIERRO|N||92|1|ug/dL|50|170|50 - 170",
    "W02181705|W02181705|375978A|Marta|Garcia|M0000M0005|FERRITINA|N||44|1|ng/mL|15|150|15 - 150",
    "W02181705|W02181705|375978A|Marta|Garcia|V0000V0001|VITAMINA D 25-OH|L||18|1|ng/mL|30|100|30 - 100",
    "W02181705|W02181705|375978A|Marta|Garcia|V0000V0002|VITAMINA B12|N||412|1|pg/mL|200|900|200 - 900",
    "W02181705|W02181705|375978A|Marta|Garcia|V0000V0003|ACIDO FOLICO|N||9,1|1|ng/mL|3|17|3 - 17",
    "W02181705|W02181705|375978A|Marta|Garcia|T0000T0001|TSH|N||2,1|1|uUI/mL|0,4|4,2|0,4 - 4,2",
  ].join("\n"),
  algorithmResult: {
    glucose: {
      SUCCESS: true,
      response: "G1",
      description:
        "Glucosa basal ligeramente elevada (108 mg/dL). Sin criterio de diabetes, pero conviene monitorizar para evitar deslizamiento hacia prediabetes.",
      lifestyle: [
        "Incorporar 30 minutos de actividad aeróbica 5 días/semana.",
        "Caminar 10 minutos después de las comidas principales.",
      ],
      nutrition: [
        "Reducir azúcares añadidos y bebidas azucaradas.",
        "Priorizar carbohidratos complejos (legumbres, cereales integrales).",
        "Incluir proteína y fibra en cada comida.",
      ],
      supplementation: ["Magnesio (en caso de niveles bajos, ver evaluación)."],
      clinical: ["Repetir glucosa basal y HbA1c en 3-6 meses."],
      exclusion: ["Bebidas azucaradas", "Zumos industriales", "Bollería"],
    },
    cholesterol: {
      SUCCESS: true,
      response: "C1",
      description:
        "Colesterol total y LDL ligeramente por encima del rango. HDL en buena posición. Riesgo cardiovascular bajo-moderado: optimizable con dieta y actividad.",
      lifestyle: [
        "Actividad cardiovascular moderada 150 min/semana.",
        "Reducir tiempo sentado en jornadas largas.",
      ],
      nutrition: [
        "Aceite de oliva virgen extra como grasa principal.",
        "Aumentar fibra soluble (avena, legumbres, manzana).",
        "Pescado azul 2-3 veces por semana.",
      ],
      supplementation: ["Omega 3 (1-2 g/día con comida)."],
      clinical: ["Revisión lipídica en 6 meses."],
      exclusion: ["Grasas trans", "Embutidos procesados", "Bollería industrial"],
    },
    vitaminD: {
      SUCCESS: true,
      response: "VD-",
      description:
        "Vitamina D 25-OH baja (18 ng/mL). Niveles insuficientes asociados a peor inmunidad, salud ósea y bienestar general.",
      lifestyle: ["Exposición solar segura 15-20 minutos/día (brazos y cara)."],
      nutrition: ["Pescado azul, huevos y lácteos enriquecidos."],
      supplementation: ["Vitamina D3 2.000 UI/día durante 8-12 semanas, luego reevaluar."],
      clinical: ["Reevaluar niveles a los 3 meses de suplementación."],
      exclusion: [],
    },
    magnesium: {
      SUCCESS: true,
      response: "Mg-",
      description:
        "Magnesio sérico en límite inferior (1,7 mg/dL). Puede asociarse a calambres, fatiga y peor recuperación.",
      lifestyle: ["Priorizar descanso de calidad 7-8 h."],
      nutrition: ["Verduras de hoja verde, frutos secos, semillas y cacao puro."],
      supplementation: ["Magnesio bisglicinato 200-300 mg/día por la noche, 8 semanas."],
      clinical: ["Reevaluar en analítica de control."],
      exclusion: ["Alcohol excesivo"],
    },
    zinc: {
      SUCCESS: true,
      response: "Zn-",
      description:
        "Zinc plasmático bajo (62 ug/dL). Esencial para inmunidad, piel y cicatrización.",
      lifestyle: [],
      nutrition: ["Marisco, carne magra, semillas de calabaza, legumbres."],
      supplementation: ["Zinc bisglicinato 15-25 mg/día durante 6-8 semanas, lejos del café."],
      clinical: [],
      exclusion: [],
    },
    liver: {
      SUCCESS: true,
      response: "L0",
      description:
        "Pruebas hepáticas dentro de la normalidad. GOT/GPT y GGT en rango. Buen perfil hepático.",
      lifestyle: ["Mantener actividad física regular."],
      nutrition: ["Mantener consumo de verduras y proteína de calidad."],
      supplementation: [],
      clinical: [],
      exclusion: ["Alcohol diario"],
    },
    anemia: {
      SUCCESS: true,
      response: "A0",
      description:
        "No hay datos compatibles con anemia. Hierro, ferritina y serie roja en rango.",
      lifestyle: [],
      nutrition: ["Mantener fuentes de hierro en la dieta."],
      supplementation: [],
      clinical: [],
      exclusion: [],
    },
    cametabolism: {
      SUCCESS: true,
      response: "CM0",
      description:
        "Calcio sérico normal. Vigilar la vitamina D para asegurar absorción óptima a medio plazo.",
      lifestyle: ["Carga de impacto 2-3 días/semana (caminar, saltar, fuerza)."],
      nutrition: ["Lácteos, sardinas con espina, tofu."],
      supplementation: [],
      clinical: [],
      exclusion: [],
    },
    vitaminB: {
      SUCCESS: true,
      response: "B0",
      description: "B12 y ácido fólico dentro de rango.",
      lifestyle: [],
      nutrition: ["Mantener fuentes (huevos, lácteos, legumbres, verduras de hoja)."],
      supplementation: [],
      clinical: [],
      exclusion: [],
    },
  },
};
